import React from 'react';

const ShowGoogleSearch = (props) => {
    const {results, info} = props;
    if (results) {
        
        return(
            
            results.map(result => (
                    
                    <div className='showResults'>
                        <p><b>{result.displayLink}</b></p>
                        <h4><a href={result.link}>{result.title}</a></h4>
                        <p>{result.snippet}</p>
                    </div>
            ))
          
        );
    }
    else {
        return (
            <>
                <div className='notFOundError'>
                    <img src='assets/img/no-search-icon.svg'/>
                    <h4>No Result Found</h4>
                    <p>Try some other keywords</p>
                </div>
            </>
        );
      }
    // return (
    //     <div>
             
    //         {
    //         results.length > 0 ?
    //          results.map(result => (
    //             <div className='showResults'>
    //                 <p><b>{result.displayLink}</b></p>
    //                 <h4><a href={result.link}>{result.title}</a></h4>
    //                 <p>{result.snippet}</p>
    //             </div>
    //             )
    //         ) 
    //         :'Data Not Found'
            
    //         }
          
    //     </div>
    // );
};

export default ShowGoogleSearch;